import React from "react";
import { HelpCircle } from "lucide-react";

const QUICK = { medicaid: (o) => `Medicaid: ${o}`, county: (o) => `My county is ${o}` };

export const CaseFollowUps = ({ followUps, onConfirm, onSend, busy }) => {
  const items = (followUps || []).filter((q) => q.kind !== "priorities");
  if (!items.length) return null;
  return (
    <div className="space-y-3" data-testid="case-follow-ups">
      {items.map((q, qi) => (
        <div key={`${q.kind}-${q.id || qi}`} className="rounded-xl border border-[#E5D9A8] bg-[#FFFBEA] p-4" data-testid={`case-followup-${q.kind}`}>
          <p className="flex items-start gap-2 text-base font-medium text-[#0B192C]"><HelpCircle className="mt-0.5 h-4 w-4 shrink-0 text-[#8A6D0B]" />{q.question}</p>
          {q.options?.length > 0 && (
            <div className="mt-3 flex flex-wrap gap-2">
              {q.options.map((o, i) => (
                <button key={i} type="button" disabled={busy}
                  onClick={() => (q.kind === "doctor" || q.kind === "med") ? onConfirm({ kind: q.kind, mention_id: q.id, option_index: i }) : onSend(QUICK[q.kind] ? QUICK[q.kind](o) : o)}
                  className="min-h-11 rounded-lg border border-[#BCCCDC] bg-white px-3 py-2 text-left text-sm text-[#1E3E62] hover:border-[#1E3E62]"
                  data-testid={`case-followup-option-${q.kind}-${i}`}>{o}</button>
              ))}
            </div>
          )}
          {(q.kind === "doctor" || q.kind === "doctor_not_found") && (
            <div className="mt-3 flex flex-wrap gap-3 text-sm">
              <button type="button" className="underline text-[#1E3E62]" onClick={() => onConfirm({ kind: "doctor", mention_id: q.id, manual: true })} data-testid={`case-doctor-manual-${q.id}`}>Keep as a doctor to verify</button>
              <button type="button" className="underline text-[#7A8794]" onClick={() => onConfirm({ kind: "doctor", mention_id: q.id, remove: true })} data-testid={`case-doctor-remove-${q.id}`}>Remove</button>
            </div>
          )}
          {(q.kind === "med" || q.kind === "med_not_found") && (
            <button type="button" className="mt-3 text-sm underline text-[#7A8794]" onClick={() => onConfirm({ kind: "med", mention_id: q.id, remove: true })} data-testid={`case-med-remove-${q.id}`}>Remove this medication</button>
          )}
        </div>
      ))}
    </div>
  );
};
